import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './Card.scss'


const Card = ({ children, className, size, withBg, onClick, dataTestId, withShadow }) => {
  const rootClassName = cx(className, s.card, {
    [s[`size-${size}`]]: Boolean(size),
    [s.withBg]: withBg,
    [s.withShadow]: withShadow,
  })

  return (
    <div className={rootClassName} onClick={onClick} data-testid={dataTestId}>
      {children}
    </div>
  )
}

Card.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf([ 'sm', 'md' ]),
  withBg: PropTypes.bool,
  withShadow: PropTypes.bool,
  onClick: PropTypes.func,
  dataTestId: PropTypes.string,
}

Card.defaultProps = {
  size: 'md',
}


export default Card
